import React from 'react';
import { useFormContext } from 'react-hook-form';
import ProjetoInfoSection from './ProjetoInfoSection';
import ClienteInfoSection from './ClienteInfoSection';
import EnderecoFaturamentoSection from './EnderecoFaturamentoSection';
import EnderecoInstalacaoSection from './EnderecoInstalacaoSection';
import type { CategoriaArquivo } from '@engenharia/shared';

interface Props {
  onUpload: (categoria: CategoriaArquivo, file: File) => void;
  onDelete: (id: number) => void;
  uploadStates: Record<string, { uploading: boolean; progress: number }>;
}

export default function Step1Endereco({ onUpload, onDelete, uploadStates }: Props) {
  const { watch } = useFormContext();
  const tipoSolicitacao = watch('tipo_solicitacao');
  const isVenda = tipoSolicitacao === 'VendaConcluida';

  return (
    <div>
      <ProjetoInfoSection />

      {isVenda && <ClienteInfoSection />}
      {isVenda && (
        <EnderecoFaturamentoSection
          onUpload={onUpload}
          onDelete={onDelete}
          uploadStates={uploadStates}
        />
      )}

      <EnderecoInstalacaoSection
        isVendaConcluida={isVenda}
        onUpload={onUpload}
        onDelete={onDelete}
        uploadStates={uploadStates}
      />
    </div>
  );
}
